import { createTheme } from '@mui/material/styles';

// Scoped to the public marketing site only (wrapped around PublicLayout) -
// deliberately a full, separate theme rather than an extension of the app's
// theme, so the authenticated product keeps its own look untouched. Warm/
// editorial direction, chosen with the user from three sketched options.
export const publicTheme = createTheme({
  palette: {
    primary: {
      main: '#B4552F', // Terracotta - CTAs
      light: '#C97951',
      dark: '#8F4224',
      contrastText: '#FBF6EC',
    },
    secondary: {
      main: '#2E5339', // Forest green - links, accents, secondary actions
      light: '#4A7052',
      dark: '#1F3B28',
      contrastText: '#FBF6EC',
    },
    background: {
      default: '#FBF6EC', // Cream
      paper: '#FFFDF7',
    },
    text: {
      primary: '#2E2A22', // Ink
      secondary: '#5C5245',
    },
    divider: '#E7DBC0',
  },
  typography: {
    fontFamily: '"Source Sans 3", "Helvetica Neue", Arial, sans-serif',
    h1: { fontFamily: '"Lora", Georgia, serif', fontWeight: 600, letterSpacing: '-0.005em' },
    h2: { fontFamily: '"Lora", Georgia, serif', fontWeight: 600, letterSpacing: '-0.005em' },
    h3: { fontFamily: '"Lora", Georgia, serif', fontWeight: 600 },
    h4: { fontFamily: '"Lora", Georgia, serif', fontWeight: 600 },
    h5: { fontFamily: '"Lora", Georgia, serif', fontWeight: 600 },
    h6: { fontFamily: '"Lora", Georgia, serif', fontWeight: 600 },
    button: {
      fontFamily: '"Source Sans 3", sans-serif',
      fontWeight: 600,
      textTransform: 'none',
    },
  },
  shape: {
    borderRadius: 14,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          padding: '10px 24px',
        },
        containedPrimary: {
          boxShadow: 'none',
          '&:hover': { boxShadow: 'none' },
        },
        outlined: {
          borderWidth: '1.5px',
          '&:hover': { borderWidth: '1.5px' },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 14,
          border: '1px solid #E7DBC0',
          boxShadow: '0 2px 10px rgba(180, 85, 47, 0.06)',
          backgroundImage: 'none',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 20,
          fontWeight: 600,
        },
      },
    },
  },
});
